import { render, staticRenderFns } from "./JourneyBrickMenu.vue?vue&type=template&id=5a2f4e4b&scoped=true&"
import script from "./JourneyBrickMenu.vue?vue&type=script&lang=js&"
export * from "./JourneyBrickMenu.vue?vue&type=script&lang=js&"
import style0 from "../../Style/journey-brick-menu.scss?vue&type=style&index=0&id=5a2f4e4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f4e4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2f4e4b')) {
      api.createRecord('5a2f4e4b', component.options)
    } else {
      api.reload('5a2f4e4b', component.options)
    }
    module.hot.accept("./JourneyBrickMenu.vue?vue&type=template&id=5a2f4e4b&scoped=true&", function () {
      api.rerender('5a2f4e4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBrickMenu.vue"
export default component.exports